module.exports = __webpack_public_path__ + "assets/icons/link_black_24dp-00d0.svg";